import * as React from "react";

const IconCircleChecked: React.FunctionComponent<{}> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.90039 11.9999C1.90039 6.42183 6.42232 1.8999 12.0004 1.8999C17.5785 1.8999 22.1004 6.42183 22.1004 11.9999C22.1004 17.578 17.5785 22.0999 12.0004 22.0999C6.42232 22.0999 1.90039 17.578 1.90039 11.9999ZM17.3619 9.36977C17.6766 9.05967 17.6804 8.55315 17.3703 8.23843C17.0602 7.9237 16.5537 7.91995 16.2389 8.23005L10.0046 14.3727L7.56609 11.9342C7.25367 11.6218 6.74714 11.6218 6.43472 11.9342C6.1223 12.2466 6.1223 12.7532 6.43472 13.0656L9.43472 16.0656C9.74551 16.3764 10.2488 16.3782 10.5619 16.0698L17.3619 9.36977Z"
          fill="#0068FF"
        />
      </g>
    </svg>
  );
};

export default IconCircleChecked;
